module.exports = __webpack_public_path__ + "img/huangguan.b8801613.png";